module.exports = __webpack_public_path__ + "img/manage.36adc30c.png";